module.exports = __webpack_public_path__ + "static/016-b850524eee07c38af1de465050ada81a.png";